import { pickGmwLibraryFields } from "../../../schema/gmw-schema-library";

import type { SourcedocumentDataSchemaFor } from "./_gmw-event-schema-collection";

export const gmwPositionsMeasuringSchema: SourcedocumentDataSchemaFor<"GMW_PositionsMeasuring"> = {
  type: "object",
  title: "Gebeurtenis gegevens",
  required: ["eventDate", "monitoringTubes"],
  properties: {
    ...pickGmwLibraryFields(["eventDate", "groundLevelPosition", "groundLevelPositioningMethod"]),
    monitoringTubes: {
      type: "array",
      title: "Monitoringsbuis",
      minItems: 1,
      items: {
        type: "object",
        required: ["tubeNumber", "tubeTopPosition", "tubeTopPositioningMethod"],
        properties: pickGmwLibraryFields([
          "tubeNumber",
          "tubeTopPosition",
          "tubeTopPositioningMethod",
        ]),
      },
    },
  },
};
